// ========================================
// 🎯 ACTION TYPES
// ========================================

export const GET_ROLE_REQUEST = 'GET_ROLE_REQUEST';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';
export const GET_ROLE_FAIL = 'GET_ROLE_FAIL';

export const GET_ALL_ROLES_REQUEST = 'GET_ALL_ROLES_REQUEST';
export const GET_ALL_ROLES_SUCCESS = 'GET_ALL_ROLES_SUCCESS';
export const GET_ALL_ROLES_FAIL = 'GET_ALL_ROLES_FAIL';

export const GET_ACTIVE_ROLES_REQUEST = 'GET_ACTIVE_ROLES_REQUEST';
export const GET_ACTIVE_ROLES_SUCCESS = 'GET_ACTIVE_ROLES_SUCCESS';
export const GET_ACTIVE_ROLES_FAIL = 'GET_ACTIVE_ROLES_FAIL';

export const GET_ROLES_BY_MODULE_REQUEST = 'GET_ROLES_BY_MODULE_REQUEST';
export const GET_ROLES_BY_MODULE_SUCCESS = 'GET_ROLES_BY_MODULE_SUCCESS';
export const GET_ROLES_BY_MODULE_FAIL = 'GET_ROLES_BY_MODULE_FAIL';

export const GET_GLOBAL_ROLES_REQUEST = 'GET_GLOBAL_ROLES_REQUEST';
export const GET_GLOBAL_ROLES_SUCCESS = 'GET_GLOBAL_ROLES_SUCCESS';
export const GET_GLOBAL_ROLES_FAIL = 'GET_GLOBAL_ROLES_FAIL';

export const CREATE_ROLE_REQUEST = 'CREATE_ROLE_REQUEST';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL';

export const UPDATE_ROLE_REQUEST = 'UPDATE_ROLE_REQUEST';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = 'UPDATE_ROLE_FAIL';

export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL';

export const SET_SELECTED_ROLE = 'SET_SELECTED_ROLE';
export const SET_SELECTED_ROLE_ADMIN = 'SET_SELECTED_ROLE_ADMIN';
export const SET_ROLE_LOADING = 'SET_ROLE_LOADING';

// ========================================
// 🎬 ACTION CREATORS
// ========================================

// --- Sélectionner un rôle actif ---
export const setSelectedRole = (role) => ({
    type: SET_SELECTED_ROLE,
    payload: role
});
export const setSelectedRoleAdmin = (role) => ({
    type: SET_SELECTED_ROLE_ADMIN,
    payload: role
});

// --- Récupérer un rôle par ID ---
export const getRoleRequest = (roleId) => ({
    type: GET_ROLE_REQUEST,
    payload: { roleId }
});

export const getRoleSuccess = (role) => ({
    type: GET_ROLE_SUCCESS,
    payload: role
});

export const getRoleFail = (error) => ({
    type: GET_ROLE_FAIL,
    error
});

// --- Récupérer tous les rôles ---
export const getAllRolesRequest = () => ({
    type: GET_ALL_ROLES_REQUEST
});

export const getAllRolesSuccess = (roles) => ({
    type: GET_ALL_ROLES_SUCCESS,
    payload: roles
});

export const getAllRolesFail = (error) => ({
    type: GET_ALL_ROLES_FAIL,
    error
});

// --- Récupérer les rôles actifs ---
export const getActiveRolesRequest = () => ({
    type: GET_ACTIVE_ROLES_REQUEST
});

export const getActiveRolesSuccess = (roles) => ({
    type: GET_ACTIVE_ROLES_SUCCESS,
    payload: roles
});

export const getActiveRolesFail = (error) => ({
    type: GET_ACTIVE_ROLES_FAIL,
    error
});

// --- Récupérer rôles par module ---
export const getRolesByModuleRequest = (moduleId) => ({
    type: GET_ROLES_BY_MODULE_REQUEST,
    payload: { moduleId }
});

export const getRolesByModuleSuccess = (roles) => ({
    type: GET_ROLES_BY_MODULE_SUCCESS,
    payload: roles
});

export const getRolesByModuleFail = (error) => ({
    type: GET_ROLES_BY_MODULE_FAIL,
    error
});

// --- Récupérer rôles globaux ---
export const getGlobalRolesRequest = () => ({
    type: GET_GLOBAL_ROLES_REQUEST
});

export const getGlobalRolesSuccess = (roles) => ({
    type: GET_GLOBAL_ROLES_SUCCESS,
    payload: roles
});

export const getGlobalRolesFail = (error) => ({
    type: GET_GLOBAL_ROLES_FAIL,
    error
});

// --- Créer un rôle ---
export const createRoleRequest = (roleData) => ({
    type: CREATE_ROLE_REQUEST,
    payload: roleData
});

export const createRoleSuccess = (role) => ({
    type: CREATE_ROLE_SUCCESS,
    payload: role
});

export const createRoleFail = (error) => ({
    type: CREATE_ROLE_FAIL,
    error
});

// --- Mettre à jour un rôle ---
export const updateRoleRequest = (roleId, roleData) => ({
    type: UPDATE_ROLE_REQUEST,
    payload: { roleId, roleData }
});

export const updateRoleSuccess = (role) => ({
    type: UPDATE_ROLE_SUCCESS,
    payload: role
});

export const updateRoleFail = (error) => ({
    type: UPDATE_ROLE_FAIL,
    error
});

// --- Supprimer un rôle ---
export const deleteRoleRequest = (roleId) => ({
    type: DELETE_ROLE_REQUEST,
    payload: { roleId }
});

export const deleteRoleSuccess = (roleId) => ({
    type: DELETE_ROLE_SUCCESS,
    payload: { roleId }
});

export const deleteRoleFail = (error) => ({
    type: DELETE_ROLE_FAIL,
    error
});

// --- Loading ---
export const setRoleLoading = (loading) => ({
    type: SET_ROLE_LOADING,
    payload: loading
});